import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

import { ThemeService } from './core/services/theme.service';
import { AuthService } from './core/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastModule
],
  templateUrl: './app.component.html'
})
export class AppComponent {
  themeService = inject(ThemeService);
  isDarkMode = this.themeService.isDarkMode;

  constructor() { }

}